import * as React from 'react';
import axios from 'axios';
import authService from './api-authorization/AuthorizeService';
import { toast } from 'react-toastify';

interface JobQuoteHistoryProps {
    jobId: number;
    systemCompanyId: number;
    siteAddress: string;
    goQuote(tab: string): void;
}

interface JobQuoteHistory {
    loading: boolean;
    jobQuotes: JobQuoteDetails[];
}

interface JobQuoteDetails {
    id: number;
    jobId: number;
    versionNumber: number;
    quoteNo: number;
    manualQuoteNumber: string;
    totalQuotedAmount: string;
    jobQuoteItems: JobQuoteItems[];
}

interface JobQuoteItems {
    itemIndex: number;
    id: number;
    item: string;
    itemId: number;
    isVoid: boolean;
    isWalkWay: boolean;
    unitOfMeasure: string;
    hirePeriod: number;
    hirePeriodWeeks: number;
    frequency: string;
    size: number;
    quantity: number;
    travelAmountFormatted: string;
    fuelSurchargeAmountFormatted: string;
    extraHours: number;
    amountFormatted: number;
    overhireRateFormatted: number;
    notes: string;
    quoteNote: string;  //max 20 chars to go on the quote under the item name
}

export default class JobQuoteHistoryData extends React.Component<JobQuoteHistoryProps, JobQuoteHistory> {
    constructor(props: JobQuoteHistoryProps) {
        super(props);
        this.state = {  
            loading: true,
            jobQuotes: []
        }
    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        const token = await authService.getAccessToken();

        axios.get('api/Job/GetQuoteHistory?JobId=' + this.props.jobId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
            .then(res => {
                this.setState({ jobQuotes: res.data, loading: false });
            })
            .catch(error => {
                toast.error(error.message);
            });
    }

    goToQuote = () => {
        this.props.goQuote("Quote");
    }

    printJobQuote = (jobQuoteId: number) => {
        var reportName = this.props.systemCompanyId === 3 ? "JobRequest" : "JobQuote";

        var url = "/job/" + this.props.jobId + "/report/" + reportName + "/" + jobQuoteId;
        window.open(url, '_blank');      
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderQuote();


        return (
            <div>
                <div className="makeitflexspacebetween">
                    <h1>Quote History</h1>
                    <button type="button" className="defaultbutton" onClick={this.goToQuote}>Back to Quote</button>
                </div>
                {contents}
            </div>
        );
    }

    renderQuote = () => {
        let quotes = this.state.jobQuotes;
        let jobQuoteHeading = this.props.systemCompanyId === 3 ? "Print Job Request" : "Print Job Quote";

        return (
            <div className="quoteHistoryTable">
                {quotes.map((quote, index) =>
                    <div key={quote.id} className="scheduleRow marginTop10 paddingFull10">
                        <h4>Version Number: {quote.versionNumber}</h4>
                        <div className="overflowHideVertical">
                            <table className="table table__large tableColours">
                                <thead>
                                    <tr>
                                        <th className="hidden">Id</th>
                                        <th></th>
                                        <th>Item</th>
                                        <th>Hire Period {this.props.systemCompanyId === 2 ? "(days)" : "(weeks)"}</th>
                                        <th className={this.props.systemCompanyId === 3 ? "" : "hidden"} >Maint.</th>
                                        <th className={this.props.systemCompanyId === 3 ? "hidden" : ""}>Void Size</th>
                                        <th>Quantity</th>
                                        <th className="textalignright">Travel ($)</th>
                                        <th className="textalignright">Fuel Surcharge ($)</th>
                                        <th className="textalignright">Extra Hours</th>
                                        <th className="textalignright">Amount ($)</th>
                                        <th className="textalignright">Overhire Rate ($)</th>
                                        <th>Notes</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {quote.jobQuoteItems.map((item, index) =>
                                        <tr key={index}>
                                            <td className="hidden">{item.id}</td>
                                            <td className="table__text--align">{index + 1}</td>
                                            <td className="table__text--align">{item.item}</td>
                                            <td className="table__text--align">{this.props.systemCompanyId === 2 ? item.hirePeriod : item.hirePeriodWeeks}</td>
                                            <td className={this.props.systemCompanyId === 3 ? "table__text--align" : "hidden"}>{item.frequency}</td>
                                            <td className={this.props.systemCompanyId === 3 ? "hidden" : "table__text--align"}>{item.isVoid ? item.size + " m2" : ""}</td>
                                            <td className="table__text--align">{item.quantity} {item.unitOfMeasure}</td>
                                            <td className="table__text--align textalignright">{item.travelAmountFormatted}</td>
                                            <td className="table__text--align textalignright">{item.fuelSurchargeAmountFormatted}</td>
                                            <td className="table__text--align textalignright">{item.extraHours}</td>
                                            <td className="table__text--align textalignright">{item.amountFormatted}</td>
                                            <td className="table__text--align textalignright">{item.overhireRateFormatted}</td>
                                            <td className="table__text--align">
                                                <div className="tooltipitem tooltipitem__left">{item.notes ? item.notes.substring(0, 20) + "... " : ""}
                                                    <span className="tooltipitemtext tooltipitemtext__left">{item.notes}</span>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <div>
                            <button className="defaultbutton" type="button" onClick={(e) => this.printJobQuote(quote.id)}>{jobQuoteHeading}</button>
                        </div>
                    </div>
                )}
            </div>
        )
    }

}